import { Prescription, License } from '../../types/data';
import Status from '../status/status';
import UserInfo from '../user-info/user-info';

type RowProps = {
  data: Prescription & License;
  onRowClick: (data: Prescription & License) => void;
};

function Row({ data, onRowClick }: RowProps) {
  const {
    prescriptionNumber,
    documentNumber,
    location,
    direction,
    typeActivity,
    dateVerification,
    documentType,
    responsible,
    status,
    deadlineExecutionOrder,
    startDateDocument,
    actualClosingDatePrescription,
    expirationDateDocument,
    actionStatus,
  } = data;

  const handleRowClick = () => {
    onRowClick(data);
  };

  return (
    <tr className='text-primaryGray hover:bg-slate-100 cursor-pointer border-b border-slate-300' onClick={handleRowClick}>
      <td className='py-4 text-[#012169] pr-2'>{prescriptionNumber || documentNumber}</td>
      <td className='py-4 pr-2'>{location?.name}</td>
      <td className='py-4 pr-2'>{direction?.name || typeActivity?.name}</td>
      <td className='py-4 pr-2'>{(dateVerification?.startDate?.toLocaleDateString('ru-RU') || documentType?.name) ?? '—'}</td>
      <td className='py-4 pr-2'>
        <UserInfo {...responsible} />
      </td>
      <td className='py-4 pr-2'>
        <Status type={status.name} />
      </td>
      <td className='py-4'>{(deadlineExecutionOrder?.startDate?.toLocaleDateString('ru-RU') || startDateDocument?.startDate?.toLocaleDateString('ru-RU')) ?? '—'}</td>
      <td className='py-4'>{(actualClosingDatePrescription?.startDate?.toLocaleDateString('ru-RU') || expirationDateDocument?.startDate?.toLocaleDateString('ru-RU')) ?? '—'}</td>
      <td className='py-4'>
        <Status type={actionStatus} />
      </td>
    </tr>
  );
}

export default Row;
